const topics = [
  { name: '科幻巨制', icon: 'ri-rocket-2-line', count: '3.2万讨论', color: 'bg-primary-100 text-primary-600' },
  { name: '悬疑剧场', icon: 'ri-search-eye-line', count: '2.8万讨论', color: 'bg-accent-100 text-accent-600' },
  { name: '古装仙侠', icon: 'ri-magic-line', count: '2.5万讨论', color: 'bg-secondary-100 text-secondary-600' },
  { name: '甜宠爱情', icon: 'ri-heart-line', count: '2.1万讨论', color: 'bg-primary-100 text-primary-600' },
  { name: '爆笑喜剧', icon: 'ri-emotion-happy-line', count: '1.9万讨论', color: 'bg-accent-100 text-accent-600' },
  { name: '动漫热番', icon: 'ri-ghost-smile-line', count: '1.7万讨论', color: 'bg-secondary-100 text-secondary-600' },
  { name: '纪录纪实', icon: 'ri-earth-line', count: '1.5万讨论', color: 'bg-primary-100 text-primary-600' },
  { name: '烧脑推理', icon: 'ri-lightbulb-line', count: '1.3万讨论', color: 'bg-accent-100 text-accent-600' },
  { name: '动作大片', icon: 'ri-sword-line', count: '1.2万讨论', color: 'bg-secondary-100 text-secondary-600' },
  { name: '恐怖惊悚', icon: 'ri-ghost-line', count: '9.8千讨论', color: 'bg-primary-100 text-primary-600' },
  { name: '经典怀旧', icon: 'ri-time-line', count: '8.5千讨论', color: 'bg-accent-100 text-accent-600' },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary-100/80 text-primary-700 text-xs font-medium mb-4">
            <i className="ri-hashtag"></i>
            <span className="whitespace-nowrap">热门讨论</span>
          </div>
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950">热门话题</h2>
          <p className="mt-2 text-sm text-foreground-500">全网影迷都在讨论什么？来看看热门话题标签</p>
        </div>

        <div className="flex flex-wrap justify-center gap-3">
          {topics.map((topic) => (
            <a
              key={topic.name}
              href="#topics"
              className="group inline-flex items-center gap-2 px-4 py-2.5 rounded-full bg-background-50 border border-background-200/60 hover:border-primary-200 hover:bg-primary-50/40 transition-all cursor-pointer whitespace-nowrap"
            >
              <span className={`w-7 h-7 flex items-center justify-center rounded-full ${topic.color} text-sm`}>
                <i className={topic.icon}></i>
              </span>
              <span className="text-sm font-medium text-foreground-800 group-hover:text-primary-600 transition-colors">{topic.name}</span>
              <span className="text-xs text-foreground-400">{topic.count}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}